import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

// KP - 14/06/2023 : ajout niveaux administratifs
export const IDS_NIVEAU = {
    NATIONAL: "National",
    REGION: "Région",
    AGENCE: "Agence",
    PROGRAMME: "Programme",
    OPERATION: "Opération",
    LOT: "Lot",
    REGION_ADMINISTRATIVE: "Région administrative",
    DEPARTEMENT_ADMINISTRATIF: "Département administratif",
    VILLE_ADMINISTRATIVE: "Ville administrative",
};

export class ComboBoxNiveau extends Component {

    static defaultProps = {
        inclureLot: true,
        inclureOperation: true,
        inclureProgramme: true,
        inclureNational: true,
        label: "Niveau",
        placeholder: "Niveau",
    };

    render = () => {

        const { inclureLot, inclureOperation, inclureProgramme, inclureNational } = this.props;

        const fetchMethod = () => new Promise((resolve, reject) => {
            let options = [];
            for (const [key, value] of Object.entries(IDS_NIVEAU)) {
                if (value === "Lot" && !inclureLot);
                else if (value === "Opération" && !inclureOperation);
                else if (value === "Programme" && !inclureProgramme);
                else if (value === "National" && !inclureNational);
                else if (value === "Région administrative" || value === "Département administratif" || value === "Ville administrative"); // Niveaux administratifs masqués dans la ComboBox

                else options.push({ key: value, text: value });
            }
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
            stamp={[inclureLot, inclureOperation, inclureProgramme]}
        />;

    };

};